import classNames from "classnames";
import scss from "@/styles/pages/who-we-are/mission-heading.module.scss";

export const wrapper = classNames(
    // Mobile
    "mobile:p-2",
    // Tablet
    "tablet:p-10",
    // All
    "flex",
    "flex-col",
    "items-center",
    "justify-center"
);
export const headingItem = classNames(
    //
    "flex",
    "items-center", 
    "justify-center",
    "w-full"
);

export const heading = classNames(
    // Mobile
    "mobile:w-1/2",
    "mobile:text-xl",
    scss["missionHeading"],
    // Tablet
    "mobile-lg:w-1/3",
    "mobile-lg:p-5"
);

export const content = classNames(
    // Mobile
    "mobile:p-2",
    "mobile:ml-2",
    "mobile:text-base",
    // Tablet
    "tablet:p-6",
    "tablet:text-2xl",
    // All
    "w-1/2",
    "font-normal",
	"mt-4"
);
